<template>
  <div>
    <b-row>
      <b-col :cols="canvas_cols">
        <b-card no-body class="canvas-container">
          <div class="tabs"  v-if="files.length > 1 && activeFile">
            <div class="card-header" >
              <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item" role="presentation" v-for="file in files" :key="file.id">
                  <a class="nav-link" :class="{ 'active': activeFile.id === file.id }"
                    @click.prevent="activeFile = file" href="#">{{ file.name }}</a>
                </li>
              </ul>
            </div>
          </div>
          <canvas ref="canvas" style="width:100%; padding: 0; margin: 0" tabindex=0 contenteditable="true"
            :style="{ 'cursor': cursor_type }" @contextmenu.prevent @keydown="keydown_canvas"
            @mousedown="mousedown_canvas" @wheel.prevent="mousewheel_canvas" />
          <canvas ref="hidden_canvas" class="hidden_canvas" width="10000" height="10000" />
          <canvas ref="brush_canvas" class="brush_canvas" />

          <TagSelect v-if="show_selected_tags && active_layer"
            :placeholder="$dt('label__set_samples_list.placeholders.tags', 'No tags (click to add)')" config="async"
            :delayed="false" style="position: absolute; top: 300px; right: 50px; width: 200px;"
            :custom="{ multiple: true }" :showColorCircle="true" :showColorTag="true" v-model="active_layer.tags"
            @close="send_layer_updates" />

        </b-card>
        <b-card v-if="samMode" no-body class="p-4">
          <b-row>
            <b-col>
              <h6><b-badge>m1</b-badge> Add dots to inlcude</h6>
              <h6><b-badge>m2</b-badge> Add dots to exclue</h6>
              <h6><b-badge>m3 + image</b-badge> Drag image</h6>
              <h6><b-badge>m1 on dot</b-badge> Remove dot</h6>
              <h6><b-badge>ctrl + s</b-badge> Accept polygon</h6>
              <h6><b-badge>Exc</b-badge> Exit Sam mode</h6>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-else no-body class="p-4">
          <b-row>
            <b-col>
              <h6><b-badge>shift + m1</b-badge> Add dots, create mode</h6>
              <h6><b-badge>m1 + image</b-badge> Drag image</h6>
              <h6><b-badge>m3 + image</b-badge> Drag image</h6>
              <h6><b-badge>ctrl + h</b-badge> Hide / show menu</h6>
              <h6><b-badge>ctrl + q</b-badge> Hide / show tags</h6>
              <h6><b-badge>PageUp</b-badge> Next sample</h6>
              <h6><b-badge>PageDown</b-badge> Previous sample</h6>
            </b-col>
            <b-col>
              <h6><b-badge>m1 + object</b-badge> Select object, edit mode</h6>
              <h6><b-badge>m1 + object + move</b-badge> Drag object</h6>
              <h6><b-badge>m1 + point + move</b-badge> Drag point</h6>
              <h6><b-badge>shift + m1</b-badge> Insert one dot</h6>
              <h6><b-badge>shift + m2</b-badge> Remove dots</h6>
              <h6><b-badge>ctrl + e</b-badge> Hide / show object</h6>
            </b-col>
            <b-col>
              <h6><b-badge>ctrl + m1 + object</b-badge> Multi selection mode</h6>
              <h6><b-badge>m1 + object + move</b-badge> Drag objects</h6>
              <h6><b-badge>m3 + image</b-badge> Drag image</h6>
              <h6><b-badge>ctrl + a</b-badge> Select all</h6>
              <h6><b-badge>b + m1</b-badge> Start drawing</h6>
              <h6><b-badge>b + m2</b-badge> Erase drawing </h6>
              <h6><b-badge>b + scroll</b-badge> Change brush size</h6>
            </b-col>
            <b-col>
              <h6><b-badge>Delete</b-badge> Delete selected</h6>
              <h6><b-badge>ctrl + z</b-badge> Undo (5 times)</h6>
              <h6><b-badge>ctrl + s</b-badge> Save</h6>
              <h6><b-badge>ctrl + c</b-badge> Copy selected</h6>
              <h6><b-badge>ctrl + v</b-badge> Paste copied (click canvas)</h6>
              <h6><b-badge>ctrl + <i class="fa fa-arrow-up"></i> or <i class="fa fa-arrow-down"></i></b-badge> Change polygon position</h6>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-if="show_menu">
        <slot name="form"></slot>
        <b-card v-if="poly_edit.multi_selection">
          <b-row>
            <b-col>Polygons selected: {{ poly_edit.multi_selection.length }}</b-col>
          </b-row>
        </b-card>

        <!-- label mask transparency-->
        <div class="mt-1">
          <label style="margin: 0;">{{ $dt('segment_iface.opacity', 'Opacity: ') }}: {{ mask_transparency }}</label>
          <b-form-input :value="mask_transparency" @input="setMaskTransparency" type="range" min="0.0" max="1.0"
            step="0.05" data-toggle="tooltip" title="Mask transparency"></b-form-input>
        </div>

        <b-card v-if="samMode">
          <!-- Sam contour threshold -->
          <div class="mt-1">
            <label style="margin: 0;">
              {{ $dt('segment_iface.sam_threshold', 'Sam Polygon Filter: ') }}
              <input style="width: 55px" v-model="samData.threshold" @input="(e) => { setSamThreshold(e.target.value) }"
                type="number" step="0.05" />%
            </label>
            <b-form-input v-model="samData.threshold" @input="setSamThreshold" type="range" min="0" max="50" step="1"
              data-toggle="tooltip"></b-form-input>
          </div>

          <!-- Sam contour points dencity -->
          <div class="mt-1">
            <label style="margin: 0;">
              {{ $dt('segment_iface.sam_points_density', 'Sam Points Density: ') }}
              <input style="width: 45px" v-model="samData.epsilon" @input="(e) => { setSamEpsilon(e.target.value) }"
                type="number" step="0.1" />
            </label>
            <b-form-input v-model="samData.epsilon" type="range" min="0" max="100" @input="setSamEpsilon" step="1"
              data-toggle="tooltip"></b-form-input>
          </div>
        </b-card>

        <b-card @keydown="keydown_layers" no-body class="p-2">
          <b-row class="mb-2">
            <!-- <b-col align-self="center">
              <div>{{ $dt('segmentation_iface.new_object', 'New Object')}}</div>
            </b-col> -->
            <b-col class="text-right">
              <b-button :disabled="disabled" @click="add_layer(true)" size="sm" class="px-4" variant="primary">{{
        $dt('segment_iface.add_object_btn', 'Add') }}</b-button>
            </b-col>
          </b-row>

          <b-row v-for="layer in file_layers" :key="layer.uuid" :class="['obj_normal', {
        'active': is_layer_selected(layer.uuid),
        'no-poly': !layer.config.polygons.length
      }]" @click="select_layer(layer.uuid)">
            <div class="ob-color" :style="`background-color: ${get_layer_color(layer.uuid)}`"></div>
            <b-col>
              <b-row>
                <TagSelect :placeholder="$dt('label__set_samples_list.placeholders.tags', 'No tags (click to add)')"
                  config="async" :delayed="false" :custom="{ multiple: true }" :disabled="disabled"
                  :showColorCircle="true" :showColorTag="true" v-model="layer.tags" @close="send_layer_updates" />
                <b-button-group v-if="samMode == layer.uuid" class="ob-control-buttons">
                  <b-button class="btn-sam-mode btn-sm" :disabled="samData.loading || !samData.contours.length"
                    @click="acceptSamPolygon()" variant="success" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.accept-sam-polygon', 'Accept Sam Polygon')">
                    <i class="fa fa-lg fa-check" />
                  </b-button>
                  <b-button class="btn-sam-mode btn-sm" :disabled="samData.loading" @click="sendSamPoints()"
                    variant="info" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.send-sam-points', 'Send Sam Points')">
                    <i class="fa fa-lg fa-cloud-upload " />
                  </b-button>
                  <b-button class="btn-sam-mode btn-sm" :disabled="samData.loading" @click="stopSamMode()"
                    variant="danger" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.stop-sam-mode', 'Cancel sam mode')">
                    <i class="fa fa-lg fa-trash" />
                  </b-button>
                  <b-spinner v-if="samData.loading" type="grow" variant="primary" />
                </b-button-group>
                <b-button-group v-else-if="samMode" class="ob-control-buttons">
                  <b-button class="btn-sam-mode btn-sm" @click="enterSamMode(layer.uuid)" variant="info"
                    v-b-tooltip.hover.bottom :title="$dt('segmentation_iface.object-btns.sam-mode', 'Enter sam mode')">
                    <i class="fa fa-lg fa-magic" />
                  </b-button>
                </b-button-group>
                <b-button-group v-else class="ob-control-buttons">
                  <b-button class="btn-show-obj btn-sm" :disabled="disabled" @click="toggle_visible_layer(layer.uuid)"
                    :variant="visible_layers[layer.uuid] ? 'warning' : ''" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.show', 'Show/Hide object')">
                    <i class="fa fa-lg" :class="visible_layers[layer.uuid] ? 'fa-eye' : 'fa-eye-slash'" />
                  </b-button>
                  <b-button class="btn-sam-mode btn-sm" @click="enterSamMode(layer.uuid)" variant="info"
                    v-b-tooltip.hover.bottom :title="$dt('segmentation_iface.object-btns.sam-mode', 'Enter sam mode')">
                    <i class="fa fa-lg fa-magic" />
                  </b-button>
                  <b-button class="btn-add-poly btn-sm" :disabled="disabled" @click="add_polygon(layer.uuid)"
                    variant="success" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.add-poly', 'Add polygon to object')">
                    <i class="fa fa-lg fa-plus" /></b-button>
                  <b-button :class="['btn-add-hole', 'btn-sm']" :disabled="disabled" @click="add_hole()"
                    variant="outline-primary" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.add-hole', 'Add hole to object polygon')">
                    <i class="fa fa-lg fa-plus" /></b-button>
                  <!-- <b-button :class="['btn-magic-wand', 'btn-sm']" @click="refine_polygon()" variant="outline-primary"
                     v-b-tooltip.hover.bottom :title="$dt('segmentation_iface.object-btns.magic-wand','Adjust polygon using AI magic')">
                     <i class="fa fa-lg fa-solid fa-star"/></b-button> -->
                  <b-button class="btn-remove-poly btn-sm" :disabled="disabled" @click="remove_last_polygon(layer.uuid)"
                    variant="outline-danger" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.remove-poly', 'Delete polygon to object')">
                    <i class="fa fa-lg fa-minus" />
                    <span variant="light" class="poly-cnt">{{ layer.config.polygons.length }}</span>
                  </b-button>
                  <b-button class="btn-remove-layer btn-sm" :disabled="disabled" @click="remove_layer(layer.uuid)"
                    variant="danger" v-b-tooltip.hover.bottom
                    :title="$dt('segmentation_iface.object-btns.remove-layer', 'Remove/Delete object')">
                    <i class="fa fa-lg fa-trash" /></b-button>
                </b-button-group>
              </b-row>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-properties */
/* eslint-disable prefer-const */
/* eslint-disable keyword-spacing */
/* eslint-disable brace-style */
/* eslint-disable space-before-blocks */
/* eslint-disable no-continue */
/* eslint-disable prefer-template */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */

import { v4 as uuidv4 } from 'uuid';
import cloneDeep from 'lodash.clonedeep';
import { mapGetters, mapState } from 'vuex';
import check_poly from 'robust-point-in-polygon';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as cv from 'opencv.js';
import Services from '@/services/index';
import { Backend } from '@/_axios';
import * as util from '@/_segmentation_util.js';
import TagSelect from '@/views/Shared/TagSelect';
import { VTN } from '@/store/types';

export default {
  name: 'SegmentIface',
  data() {
    return {
      // canvas stuff
      img: null,
      mask: null,
      // mask_transparency: 0.5,
      fill_mask: null,
      fill_config: null,
      adding_threshold: 20,
      subtracting_threshold: 10,
      translate: [0, 0],
      zoom: 1,
      pt_radius: 8,
      small_pt_radius: 4,
      rectangle_mode: false,
      brush_mode: false,
      brush_drawing: false,
      ctrl_held: false,
      shift_held: false,
      alt_held: false,
      point_hover: false,
      fuzzy_mode: false,
      flood_fill_waiting: false,
      poly_to_update: null,
      initial_brush_size: 25,
      brush_zoom: 1,
      rectangle_start: null,
      mouse: {
        prev_pos: null,
        drag_start: null,
        drag_offset: [0, 0],
        dragging_polygon: false,
        dragging_point: false,
        drag_path_length: 0,
        on_the_fly_poly: null,
        on_the_fly_remove: false,
        m1_held: false,
        m2_held: false,
        m3_held: false
      },
      recenter_on_image_swap: true,
      selected_layer_count: 1,
      resize_observer: null,
      show_menu: true,
      show_selected_tags: false,

      // layers represent actual polygon and hole data
      layers: [],
      layers_undo: [],
      max_undo: 5,
      // these have layer id + polygon idx, these are pointers
      poly_edit: {
        selected_poly: null,
        hovered_poly: null,
        multi_selection: null
      },
      visible_layers: {},
      // tag_colors: {},

      mouseUpHandler: null,
      mouseMoveHandler: null,
      keyDownHandler: null,
      keyUpHandler: null,
      activeFile: null,
      samMode: false,
      samData: {
        loading: false,
        include: [],
        exclude: [],
        rawContours: [],
        contours: [],
        threshold: 0.5,
        img: null,
        epsilon: 1,
      },
    };
  },
  props: {
    sample_id: { type: Number, default: null },
    label_set_id: { type: Number, default: null },
    info: { type: Object, default: null },
    label_objects: { type: Array, default: null },
    disabled: { type: Boolean, default: false },
  },
  components: {
    TagSelect
  },
  computed: {
    files() { return this.info ? this.info.sample.files : []; },
    sampleSetId() { return this.info ? this.info.sample.sample_set_id : null; },
    file_layers() {
      return this.layers.filter((layer) => {
        const file_id = layer.file_id || this.files[0]?.id;

        return file_id === this.activeFile?.id;
      });
    },
    // tagsAvailable() { return this.info && this.info.label_set && this.info.label_set.label_set_tags ? this.info.label_set.label_set_tags : []; },

    ...mapState('Auth', ['activeProjectId', 'token', 'session']),
    ...mapGetters('Auth', ['fileUrl']),
    ...mapGetters('Auth', ['session']),
    mask_transparency() { return this.session('maskTransparency'); },

    ...mapGetters('Project', ['currentProjectTags', 'currentProjectId']),

    canvas_cols() { return this.show_menu ? '9' : '12'; },
    active_layer() { return this.poly_edit.selected_poly ? this.get_layer(this.poly_edit.selected_poly.layer_uuid).layer : null; },
    cursor_type() {
      if (this.flood_fill_waiting) return 'wait';
      if (this.brush_mode) return 'none';
      if (this.shift_held) return 'crosshair';
      if (this.point_hover) return 'crosshair';
      if (this.ctrl_held) return 'copy';
      return 'default';
    },
    tag_colors() {
      return this.currentProjectTags.reduce((tc, el) => ({ ...tc, [el.tag_id]: el.color }), {});
    }
  },
  watch: {
    label_objects: function (new_val, old_val) {
      this.update_layers(new_val);
    },
    currentProjectId() {
      this.update_layers(this.label_objects);
    },
    mask_transparency(value) {
      this.draw_canvas();
    },
    activeFile() {
      this.loadImage();
      this.on_image_change();
    }
  },

  mounted() {
    this.mouseUpHandler = this.mouseup_canvas.bind(this);
    this.mouseMoveHandler = this.mousemove_canvas.bind(this);
    this.keyDownHandler = this.keydown_window.bind(this);
    this.keyUpHandler = this.keyup_window.bind(this);

    window.addEventListener('mouseup', this.mouseUpHandler);
    window.addEventListener('mousemove', this.mouseMoveHandler);
    window.addEventListener('keydown', this.keyDownHandler);
    window.addEventListener('keyup', this.keyUpHandler);

    const canvas = this.$refs.canvas;
    if (canvas) {
      this.resize_observer = new ResizeObserver(this.resize_canvas.bind(this)).observe(canvas);
    }

    // Fetch and transform tag_colors to key value store: tag_id => tag_color
    // Services.projectTags.list(this.activeProjectId, { notpaginate: 1 }).then(({ data }) => {
    //   this.tag_colors = data.data.reduce((tc, el) => ({ ...tc, [el.tag_id]: el.color }), {});
    // }).catch((e) => { console.warn('Error fetching projectTags', e); });

    this.update_layers(this.label_objects);
    this.make_layers_copy();
    this.activeFile = this.files[0];
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.mouseUpHandler);
    window.removeEventListener('mousemove', this.mouseMoveHandler);
    window.removeEventListener('keydown', this.keyDownHandler);
    window.removeEventListener('keyup', this.keyUpHandler);
    if (this.resize_observer) {
      this.resize_observer.disconnect();
    }
  },
  methods: {
    loadImage() {
      Backend.get(this.fileUrl(this.activeFile.id, this.sampleSetId), { responseType: 'blob' }).then((imgResp) => {
        const urlMaker = window.URL || window.webkitURL;
        const imgDataUrl = urlMaker.createObjectURL(imgResp.data);
        this.img = new Image();
        this.img.onload = () => {
          const canvas = this.$refs.canvas;

          if (this.recenter_on_image_swap) {
            const w = this.img.naturalWidth;
            const h = this.img.naturalHeight;
            this.translate = [-w / 2, -h / 2];
            const x_zoom = canvas.width / w;
            const y_zoom = canvas.height / h;
            this.zoom = Math.min(x_zoom, y_zoom) / 1.1;
          }
          this.draw_canvas();
          const hidden_canvas = this.$refs.hidden_canvas;
          hidden_canvas.width = this.img.width;
          hidden_canvas.height = this.img.height;
        };
        this.img.src = imgDataUrl;
        this.resize_canvas();
      }).catch((e) => { console.warn('Error fetching image', e); });
    },
    enterSamMode(uuid) {
      this.visible_layers[uuid] = true;
      this.samMode = uuid;
      this.draw_canvas();
    },
    acceptSamPolygon() {
      const layer = this.layers.find((i) => i.uuid === this.samMode);
      if (layer && this.samData.contours.length) {
        this.make_layers_copy();
        // a polygon is an array of contours,
        // the first contour is the outline and the rest are holes.
        // a contour is an array of points [x, y]
        for (const contour of this.samData.contours) {
          layer.config.polygons.push([contour]);
        }
        this.send_layer_updates();
      }
      this.stopSamMode();
    },
    sendSamPoints() {
      const sendMask = true;
      const data = {
        sampleSetId: this.sampleSetId,
        fileId: this.activeFile.id,
        include: this.samData.include,
        exclude: this.samData.exclude,
        sendMask: sendMask,
      };
      this.samData.loading = true;
      Services.samPredictionsService.predict(data).then((response) => {
        if (!this.samMode) return;
        if (sendMask) {
          this.samData.img = new Image();
          this.samData.img.onload = () => {
            this.findSamContours();
            this.draw_canvas();
          };
          this.samData.img.src = `data:image/png;base64, ${response.data}`;
        } else {
          const contours = response.data.data.contours;
          this.samData.rawContours = contours;
          this.filterSamContours();
        }
      }).catch((err) => {
        console.log('err :', err);
        this.alertError({
          title: 'Sam prediction service error!',
          text: 'Check console for error'
        });
      }).finally(() => {
        this.samData.loading = false;
        this.draw_canvas();
      });
    },
    findSamContours() {
      this.samData.rawContours = util.findSamContours(this.samData.img, this.samData.epsilon);
      this.filterSamContours();
    },
    filterSamContours() {
      this.samData.contours = util.filterContours(this.samData.rawContours, this.samData.threshold, this.img);
    },
    samContourIsValid(contour) {
      if (!contour || contour.length < 3) return false;
      return true;
    },
    stopSamMode() {
      this.samData = {
        loading: false,
        include: [],
        exclude: [],
        rawContours: [],
        contours: [],
        threshold: 0.5,
        img: null,
        epsilon: 1,
      };
      this.point_hover = false;
      this.samMode = false;
      this.draw_canvas();
    },
    getClosestSamPoints(mouse_pt) {
      const threshold_distance = (this.pt_radius) / this.zoom;
      const pts = [
        ...this.get_closest_pts_in_radius([this.samData.include], mouse_pt, threshold_distance),
        ...this.get_closest_pts_in_radius([this.samData.exclude], mouse_pt, threshold_distance)
      ];
      return pts;
    },
    checkSamPointsToRemove(mouse_pt) {
      const pts = this.getClosestSamPoints(mouse_pt);
      if (pts.length > 0) {
        pts.forEach((pt) => this.remove_point([this.samData.include, this.samData.exclude], pt));
        this.point_hover = false;
        return true;
      }
      return false;
    },
    setMaskTransparency(value) {
      this.$store.dispatch(VTN.SET_SESSION_VAR, { maskTransparency: value });
    },
    setSamThreshold(value) {
      if (!this.samMode || !this.samData.img) return;
      this.samData.threshold = value;
      this.filterSamContours();
      this.draw_canvas();
    },
    setSamEpsilon(value) {
      if (!this.samMode || !this.samData.img) return;
      this.samData.epsilon = value;
      this.findSamContours();
      this.draw_canvas();
    },
    clear_hidden_canvas() {
      const hidden_canvas = this.$refs.hidden_canvas;
      if (!hidden_canvas) {
        return;
      }

      const ctx = hidden_canvas.getContext('2d');
      ctx.clearRect(0, 0, hidden_canvas.width, hidden_canvas.height);
    },
    clear_brush_canvas() {
      const brush_canvas = this.$refs.brush_canvas;
      if (!brush_canvas) {
        return;
      }

      const ctx = brush_canvas.getContext('2d');
      ctx.clearRect(0, 0, brush_canvas.width, brush_canvas.height);
    },
    drawPoint({
      ctx, pt, offset = [0, 0], strokeStyle = '#000000', fillStyle = '#ffffff', radius = this.pt_radius
    } = {}) {
      const scaled_pt_radius = radius / this.zoom;
      ctx.beginPath();
      ctx.arc(pt[0] + offset[0], pt[1] + offset[1], (scaled_pt_radius * 6) / 8, 0, 2 * Math.PI);
      ctx.fillStyle = fillStyle;
      ctx.strokeStyle = strokeStyle;
      ctx.lineWidth = (scaled_pt_radius * 2) / 8;
      ctx.fill();
      ctx.stroke();
    },
    drawContoursPoints(ctx, contours, radius) {
      for (const contour of contours) {
        for (const pt of contour) {
          this.drawPoint({ ctx, pt, radius });
        }
        ctx.closePath();
      }
    },
    drawSamPolygon(ctx, layer) {
      const color = this.get_layer_color(layer.uuid);
      let transparency_string = (Math.floor(this.mask_transparency * 255)).toString(16);
      if (transparency_string.length == 1) {
        transparency_string = '0' + transparency_string;
      }
      ctx.beginPath();
      for (const contour of this.samData.contours) {
        ctx.moveTo(contour[0][0], contour[0][1]);
        for (const pt of contour.slice(1)) {
          ctx.lineTo(pt[0], pt[1]);
        }
        ctx.closePath();
      }
      ctx.fillStyle = color + transparency_string;
      ctx.fill();
    },
    polygon_to_mask(canvas, one_object = null) {
      const ctx = canvas.getContext('2d');

      if (this.samMode) {
        const layer = this.layers.find((i) => i.uuid === this.samMode);
        if (!layer) return;
        this.drawSamPolygon(ctx, layer);
        this.drawContoursPoints(ctx, this.samData.contours, this.small_pt_radius);
        for (let i = 0; i < this.samData.include.length; i++) {
          const pt = this.samData.include[i];
          this.drawPoint({ ctx, pt, strokeStyle: 'green' });
        }
        for (let i = 0; i < this.samData.exclude.length; i++) {
          const pt = this.samData.exclude[i];
          this.drawPoint({ ctx, pt, strokeStyle: 'red' });
        }
        return;
      }

      for (let layer_idx = 0; layer_idx < this.file_layers.length; layer_idx++) {
        const layer = this.file_layers[layer_idx];

        if (one_object) {
          if (one_object != layer.uuid) {
            continue;
          }
        }
        if (!this.visible_layers[layer.uuid]) {
          continue;
        }
        for (let i = 0; i < layer.config.polygons.length; i++) {
          const poly = layer.config.polygons[i];
          const poly_info = { layer_uuid: layer.uuid, poly_idx: i };

          let offset = [0, 0];
          if (this.is_selected(poly_info) && this.mouse.dragging_polygon) {
            offset = this.mouse.drag_offset;
          }
          ctx.beginPath();
          for (const contour of poly) {
            ctx.moveTo(contour[0][0] + offset[0], contour[0][1] + offset[1]);
            for (const pt of contour.slice(1)) {
              ctx.lineTo(pt[0] + offset[0], pt[1] + offset[1]);
            }
            ctx.closePath();
          }

          let color = this.get_layer_color(layer.uuid);
          const is_selected = this.is_selected(poly_info);
          const is_hovered = this.is_same_poly(poly_info, this.poly_edit.hovered_poly);

          let transparency_string = this.getTransparencyString();
          if (is_selected) {
            transparency_string = this.getTransparencyString('selected');
          }
          if (is_hovered) {
            transparency_string = this.getTransparencyString('hovered');
          }
          color += transparency_string;
          ctx.fillStyle = color;
          ctx.fill();

          if (is_selected && !one_object) {
            for (const contour of poly) {
              for (const pt of contour) {
                const fillStyle = (!this.poly_edit.multi_selection ? '#ffffff' : '#cccccc');
                this.drawPoint({
                  ctx, pt, offset, fillStyle
                });
              }
              ctx.closePath();
            }
          } else if (this.mouse.on_the_fly_poly && layer_idx === this.file_layers.length - 1) {
            this.drawContoursPoints(ctx, poly, this.small_pt_radius);
          }
        }
      }
    },
    getTransparencyString(style) {
      let maskTransparency = parseFloat(this.mask_transparency);
      if (style === 'selected') {
        maskTransparency = this.calculateTransparency(0.3, maskTransparency);
      }
      if (style === 'hovered') {
        maskTransparency = this.calculateTransparency(0.2, maskTransparency);
      }
      let transparency_string = (Math.floor(maskTransparency * 255)).toString(16);
      if (transparency_string.length == 1) transparency_string = '0' + transparency_string;
      return transparency_string;
    },
    calculateTransparency(treshold, maskTransparency) {
      let tresholdMax = 1 - treshold;
      if (maskTransparency >= 0 && maskTransparency <= tresholdMax) {
        maskTransparency += treshold;
      } else {
        maskTransparency -= treshold;
      }
      return maskTransparency;
    },
    brush_mouse_move(mouse_pt) {
      const brush_canvas = this.$refs.brush_canvas;
      if (!brush_canvas) {
        return;
      }
      const brush_color = '#ff8822';

      const ctx = brush_canvas.getContext('2d');

      ctx.save();
      let tOffset = [0, 0];
      if (!this.mouse.dragging_polygon && !this.mouse.dragging_point) {
        tOffset = this.mouse.drag_offset;
      }
      ctx.translate(brush_canvas.width / 2, brush_canvas.height / 2);
      ctx.scale(this.zoom, this.zoom);
      ctx.translate(this.translate[0] + tOffset[0], this.translate[1] + tOffset[1]);

      ctx.fillStyle = brush_color;
      ctx.beginPath();
      ctx.arc(mouse_pt[0], mouse_pt[1], ((this.initial_brush_size / this.zoom) * this.brush_zoom) / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    },

    draw_rectangle(prev_mouse_pt, mouse_pt) {
      const brush_canvas = this.$refs.brush_canvas;
      if (!brush_canvas) {
        return;
      }
      const brush_color = '#ff8822';

      const ctx = brush_canvas.getContext('2d');
      ctx.clearRect(0, 0, brush_canvas.width, brush_canvas.height);
      ctx.save();
      let tOffset = [0, 0];
      if (!this.mouse.dragging_polygon && !this.mouse.dragging_point) {
        tOffset = this.mouse.drag_offset;
      }
      ctx.translate(brush_canvas.width / 2, brush_canvas.height / 2);
      ctx.scale(this.zoom, this.zoom);
      ctx.translate(this.translate[0] + tOffset[0], this.translate[1] + tOffset[1]);

      ctx.fillStyle = brush_color;
      let rect = {};
      rect.width = Math.abs(mouse_pt[0] - prev_mouse_pt[0]);
      rect.height = Math.abs(mouse_pt[1] - prev_mouse_pt[1]);
      if (mouse_pt[0] < prev_mouse_pt[0]) {
        rect.x = mouse_pt[0];
      }
      else {
        rect.x = prev_mouse_pt[0];
      }
      if (mouse_pt[1] < prev_mouse_pt[1]) {
        rect.y = mouse_pt[1];
      }
      else {
        rect.y = prev_mouse_pt[1];
      }
      ctx.beginPath();
      ctx.rect(rect.x, rect.y, rect.width, rect.height);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    },

    show_layers(on_or_off, layer_uuid = null) {
      for (let layer_idx = 0; layer_idx < this.layers.length; layer_idx++) {
        const layer = this.layers[layer_idx];
        if (layer.uuid != layer_uuid && !on_or_off) {
          this.visible_layers[layer.uuid] = on_or_off;
        }
        else if (on_or_off) {
          this.visible_layers[layer.uuid] = on_or_off;
        }
      }
    },
    move_hidden_canvas() {
      const canvas = this.$refs.canvas;
      const hidden_canvas = this.$refs.hidden_canvas;
      if (!hidden_canvas) {
        return;
      }
      const h_ctx = hidden_canvas.getContext('2d');
      h_ctx.save();

      let tOffset = [0, 0];
      if (!this.mouse.dragging_polygon && !this.mouse.dragging_point) {
        tOffset = this.mouse.drag_offset;
      }

      hidden_canvas.style.left = `${canvas.width / 2 + (this.translate[0] + tOffset[0]) * this.zoom}px`;
      hidden_canvas.style.top = `${canvas.height / 2 + (this.translate[1] + tOffset[1]) * this.zoom}px`;
      hidden_canvas.style.width = `${this.img.width * this.zoom}px`;
      hidden_canvas.style.height = `${this.img.height * this.zoom}px`;
      h_ctx.restore();
    },
    assign_polygons_to_objects(data) {
      let found_object = false;
      let polygon = data['polygons'] ? data['polygons'] : null;

      if (!polygon && !this.poly_to_update) {
        return;
      }
      this.poly_edit.selected_poly = this.poly_to_update ? this.poly_to_update : null;

      let layer_index = this.layers.length;
      for (let layer_idx = 0; layer_idx < this.layers.length; layer_idx++) {
        const layer = this.layers[layer_idx];

        for (let i = 0; i < layer.config.polygons.length; i++) {
          const poly_info = { layer_uuid: layer.uuid, poly_idx: i };

          if (this.is_same_poly(poly_info, this.poly_edit.selected_poly)) {
            found_object = true;
            this.poly_edit.selected_poly = null;
            layer.config.polygons = [];
            layer_index = layer_idx;
            break;
          }
        }
        if (found_object) {
          break;
        }
      }
      if (polygon.length > 0) {
        if (!found_object) {
          this.add_layer(false);
        }
        for (let i = 0; i < polygon.length; i++) {
          this.layers[layer_index].config.polygons.push(polygon[i]);
        }
        this.send_layer_updates();
      }
    },
    get_rectangle(prev_pos, pos) {
      let data = {};
      let rectangle = [];
      rectangle.push([prev_pos[0], pos[1]]);
      rectangle.push([pos[0], pos[1]]);
      rectangle.push([pos[0], prev_pos[1]]);
      rectangle.push([prev_pos[0], prev_pos[1]]);
      data['polygons'] = [[rectangle]];
      this.assign_polygons_to_objects(data);
    },
    draw_with_brush(pos, prev_pos = null, is_erasing = false) {
      const canvas = this.$refs.canvas;
      const hidden_canvas = this.$refs.hidden_canvas;
      if (!hidden_canvas) {
        return;
      }
      hidden_canvas.style.visibility = 'visible';
      const h_ctx = hidden_canvas.getContext('2d');
      h_ctx.save();

      let tOffset = [0, 0];
      if (!this.mouse.dragging_polygon && !this.mouse.dragging_point) {
        tOffset = this.mouse.drag_offset;
      }

      hidden_canvas.style.left = `${canvas.width / 2 + (this.translate[0] + tOffset[0]) * this.zoom}px`;
      hidden_canvas.style.top = `${canvas.height / 2 + (this.translate[1] + tOffset[1]) * this.zoom}px`;
      hidden_canvas.style.width = `${this.img.width * this.zoom}px`;
      hidden_canvas.style.height = `${this.img.height * this.zoom}px`;

      let found_object = false; /// //////////////////// black magic
      let layer_uuid = null;
      for (let layer_idx = 0; layer_idx < this.layers.length; layer_idx++) {
        const layer = this.layers[layer_idx];

        for (let i = 0; i < layer.config.polygons.length; i++) {
          const poly_info = { layer_uuid: layer.uuid, poly_idx: i };

          if (this.is_same_poly(poly_info, this.poly_edit.selected_poly)) {
            found_object = true;
            layer_uuid = layer.uuid;
            this.polygon_to_mask(hidden_canvas, layer.uuid);
            this.poly_to_update = this.poly_edit.selected_poly;
            this.poly_edit.selected_poly = null;
            break;
          }
        }
        if (found_object) {
          break;
        }
      }
      this.show_layers(false, layer_uuid);
      this.draw_canvas();
      const brush_color = '#ff8822';
      const brush_size = ((this.initial_brush_size / this.zoom) * this.brush_zoom);

      if (is_erasing) {
        h_ctx.globalCompositeOperation = 'destination-out';
        h_ctx.strokeStyle = '#000';
        h_ctx.fillStyle = '#ffffff';
      }
      else {
        h_ctx.fillStyle = brush_color;
      }
      h_ctx.beginPath();
      h_ctx.arc(pos[0], pos[1], brush_size / 2, 0, Math.PI * 2);
      h_ctx.closePath();
      h_ctx.fill();

      if (prev_pos) {
        h_ctx.strokeStyle = brush_color;
        h_ctx.lineWidth = brush_size;
        h_ctx.beginPath();
        h_ctx.moveTo(prev_pos[0], prev_pos[1]);
        h_ctx.lineTo(pos[0], pos[1]);
        h_ctx.closePath();
        h_ctx.stroke();
      }
      if (is_erasing) {
        h_ctx.globalCompositeOperation = 'source-over';
      }
      h_ctx.restore();
    },
    convert_drawing_to_poly() {
      const hidden_canvas = this.$refs.hidden_canvas;
      if (!hidden_canvas) {
        return;
      }
      const h_ctx = hidden_canvas.getContext('2d');
      h_ctx.save();

      let base64_data = hidden_canvas.toDataURL('image/png');
      let mask_base64_data = base64_data.substr(22, base64_data.length);

      this.fill_config = {
        only_mask: false,
      };

      // @DEPRECATED
      Services.sampleLabelSets.get_image_polygons(this.activeProjectId, this.label_set_id, this.sample_id, {
        mask_polygon: mask_base64_data,
        mask_config: this.fill_config,
        without_original: true,
      }).then(({ data }) => {
        this.assign_polygons_to_objects(data);
        this.poly_edit.selected_poly = null;
        this.poly_to_update = null;
      });
    },
    flood_fill_contour(pos_in_image, mask_filling, return_mask) {
      const hidden_canvas = this.$refs.hidden_canvas;
      if (!hidden_canvas) {
        return;
      }
      hidden_canvas.style.visibility = 'hidden';
      const h_ctx = hidden_canvas.getContext('2d');
      h_ctx.save();
      this.fill_config = {
        position: pos_in_image,
        mask_filling: mask_filling,
        only_mask: return_mask,
        // polygon: this.poly_edit.selected_poly ? [this.get_poly(this.poly_edit.selected_poly)] : null,
        threshold: mask_filling ? this.adding_threshold : this.subtracting_threshold,
      };
      if (this.poly_edit.selected_poly) {
        this.show_layers(false, this.poly_edit.selected_poly.layer_uuid);
        this.draw_canvas();
        this.polygon_to_mask(hidden_canvas, this.poly_edit.selected_poly.layer_uuid);
        this.poly_to_update = this.poly_edit.selected_poly;
        this.poly_edit.selected_poly = null;
      }
      else {
        if (this.mask) {
          h_ctx.drawImage(this.mask, 0, 0);
        }
      }

      let base64_data = hidden_canvas.toDataURL('image/png');
      let mask_base64_data = base64_data.substr(22, base64_data.length);

      this.flood_fill_waiting = true;
      // @DEPRECATED
      Services.sampleLabelSets.get_image_polygons(this.activeProjectId, this.label_set_id, this.sample_id, {
        mask_polygon: mask_base64_data,
        mask_config: this.fill_config,
        without_original: false,
      }).then(({ data }) => {
        this.clear_hidden_canvas();
        if (return_mask) {
          this.mask = new Image();
          let mask_base64 = 'data:image/png;base64,' + data;
          this.mask.onload = () => {
            this.draw_canvas();
          };
          this.mask.src = mask_base64;
          // this.fill_mask = data;
          // this.$refs.test_img.src = mask_base64;
        }
        else {
          this.assign_polygons_to_objects(data);
          this.mask = null;
          this.fill_mask = null;
          this.fill_config = null;
          this.adding_threshold = 20;
          this.subtracting_threshold = 10;
          this.poly_to_update = null;
        }
        this.flood_fill_waiting = false;
      });
      h_ctx.restore();
    },

    // autocompleteTag({ action, searchQuery, callback }) {
    //   if (action === ASYNC_SEARCH) {
    //     Services.tags.list({ notpaginate: 1, search: searchQuery }).then(({ data }) => {
    //       const options = data.data.map((i) => ({
    //         id: i.id,
    //         label: `${i.id} ${i.name}`,
    //       }));
    //       callback(null, options);
    //     });
    //   }
    // },
    resize_canvas() {
      const canvas = this.$refs.canvas;
      if (canvas) {
        // canvas is going to be a square for now
        canvas.width = canvas.clientWidth;
        canvas.height = (canvas.width * 9) / 16;
      }

      const brush_canvas = this.$refs.brush_canvas;
      if (brush_canvas) {
        brush_canvas.width = brush_canvas.clientWidth;
        brush_canvas.height = (brush_canvas.width * 9) / 16;
      }

      this.draw_canvas();
    },
    draw_canvas() {
      const canvas = this.$refs.canvas;
      const hidden_canvas = this.$refs.hidden_canvas;
      if (!canvas) {
        return;
      }

      const ctx = canvas.getContext('2d');
      ctx.save();
      const h_ctx = hidden_canvas.getContext('2d');
      h_ctx.save();
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let tOffset = [0, 0];
      if (!this.mouse.dragging_polygon && !this.mouse.dragging_point) {
        tOffset = this.mouse.drag_offset;
      }
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.scale(this.zoom, this.zoom);
      ctx.translate(this.translate[0] + tOffset[0], this.translate[1] + tOffset[1]);

      if (this.img) {
        ctx.drawImage(this.img, 0, 0);
        if (this.mask) {
          ctx.globalAlpha = 0.5;
          ctx.drawImage(this.mask, 0, 0);
          ctx.globalAlpha = 1;
        }
      }

      this.polygon_to_mask(canvas);
      ctx.restore();
      h_ctx.restore();
    },

    validate_contours(contours) {
      for (const c of contours) {
        if (c.length < 1) {
          throw Error();
        }
        for (const p of c) {
          if (p.length != 2) {
            throw Error();
          }
          for (const val of p) {
            if (typeof val !== 'number') {
              throw Error();
            }
          }
        }
      }
    },
    save() {
      if (this.samMode) {
        this.acceptSamPolygon();
      }
      this.$emit('save-requested');
    },
    // keyboard events
    keydown_window(e) {
      if (this.disabled) return;
      if (e.key == 'Shift') {
        this.shift_held = true;
      }
      if (e.key == 'Alt') {
        this.alt_held = true;
      }
      if (e.key == 'Control') {
        this.ctrl_held = true;
      }
      if (e.key == 's' && e.ctrlKey) {
        e.preventDefault();
      }
      if (e.key == 'h' && e.ctrlKey) {
        this.show_menu = !this.show_menu;
        e.preventDefault();
      }
      if (e.code == 'KeyB' && !e.repeat) {
        this.brush_mode = true;
        this.brush_drawing = false;
        this.brush_mouse_move(this.mouse.prev_pos);
      }
      if (e.key == 'q' && e.ctrlKey) {
        this.show_selected_tags = !this.show_selected_tags;
      }
      if (e.key == 'r' && this.alt_held) {
        this.rectangle_mode = true;
      }
      // if(e.key == 'f' && this.ctrl_held){
      //   e.preventDefault();
      //   this.fuzzy_mode = true;
      // }
      if (e.key == 'ArrowUp' && e.ctrlKey) {
        if (this.poly_edit.selected_poly || this.poly_edit.multi_selection) {
          const selectedPolygonUuid = this.poly_edit.selected_poly
            ? this.poly_edit.selected_poly.layer_uuid
            : this.poly_edit.multi_selection[0].layer_uuid;
          const { idx } = this.get_layer(selectedPolygonUuid);
          const newIdx = idx - 1;
          if (newIdx < 0) return;
          util.arrayMove(this.layers, newIdx, idx);
          this.draw_canvas();
          this.send_layer_updates();
        }
        return;
      }
      if (e.key == 'ArrowDown' && e.ctrlKey) {
        if (this.poly_edit.selected_poly || this.poly_edit.multi_selection) {
          const selectedPolygonUuid = this.poly_edit.selected_poly
            ? this.poly_edit.selected_poly.layer_uuid
            : this.poly_edit.multi_selection[0].layer_uuid;
          const { idx } = this.get_layer(selectedPolygonUuid);
          const newIdx = idx + 1;
          if (newIdx >= this.layers.length) return;
          util.arrayMove(this.layers, newIdx, idx);
          this.draw_canvas();
          this.send_layer_updates();
        }
      }
    },
    keyup_window(e) {
      if (this.disabled) return;
      if (e.key == 'Shift') {
        this.shift_held = false;
        if (this.mouse.on_the_fly_poly) {
          this.mouse.on_the_fly_poly = null;
          this.send_layer_updates();
          this.draw_canvas();
        }
      }
      if (e.key == 'Control') {
        this.ctrl_held = false;
      }
      if (e.key == 's' && e.ctrlKey) {
        if (this.samMode) {
          this.acceptSamPolygon();
        }
        this.save();
        return;
      }
      if (e.code == 'KeyB') {
        this.brush_mode = false;
        this.brush_drawing = false;
        this.convert_drawing_to_poly();
        this.clear_hidden_canvas();
        this.clear_brush_canvas();
        this.show_layers(true);
      }
      if (e.key == 'r') {
        this.alt_held = false;
        this.rectangle_mode = false;
        this.rectangle_start = null;
        this.clear_hidden_canvas();
        this.clear_brush_canvas();
      }
      // if(e.key == 'f'){
      //   this.fuzzy_mode = false;
      //   this.flood_fill_contour([0, 0], false, false);
      //   this.show_layers(true);
      //   this.draw_canvas();
      //   this.prev_pos = null;
      // }
    },

    keydown_canvas(e) {
      if (this.disabled) return;
      if (e.key == 'Escape') {
        this.stopSamMode();
        this.poly_edit.selected_poly = null;
        this.poly_edit.multi_selection = null;
        this.draw_canvas();
        e.preventDefault();
      }
      if (e.key == 's' && e.ctrlKey) {
        return;
      }
      if (e.key == 'c' && e.ctrlKey) {
        // navigator.clipboard.writeText(JSON.stringify(this.polygons.selected));
        let polygons = null;
        if (this.poly_edit.multi_selection) {
          polygons = this.poly_edit.multi_selection.map(this.get_poly);
        }
        else if (this.poly_edit.selected_poly) {
          polygons = [this.get_poly(this.poly_edit.selected_poly)];
        }
        if (polygons) {
          navigator.clipboard.writeText(JSON.stringify(polygons));
          this.alertSuccess({
            text: 'copied!',
          });
        }
        e.preventDefault();
      }
      // if(e.key == 'x' && e.ctrlKey) {
      //   // navigator.clipboard.writeText(JSON.stringify(this.polygons.selected));
      //   // this.polygons.delete_selected();
      //   e.preventDefault();
      // }
      if (e.key == 'v' && e.ctrlKey) {
        (async () => {
          try {
            const polygons = JSON.parse(await navigator.clipboard.readText());
            for (const poly of polygons) {
              this.validate_contours(poly);
            }
            this.make_layers_copy();
            this.poly_edit.selected_poly = null;
            this.poly_edit.multi_selection = [];
            for (let polygon of polygons) {
              this.add_layer(false);
              let layer = this.layers[this.layers.length - 1];
              layer.config.polygons = [polygon];
              this.poly_edit.multi_selection.push({ layer_uuid: layer.uuid, poly_idx: 0 });
            }
            this.send_layer_updates();
            this.draw_canvas();
            this.alertSuccess({
              text: 'pasted!'
            });
          }
          catch (error) {
            console.log('failed to paste polygons! ', error);
          }
        })();
        e.preventDefault();
      }
      if (e.key == 'Delete') {
        let removable_layers = [];
        let selected_polygons = null;
        if (this.poly_edit.selected_poly) {
          selected_polygons = [this.poly_edit.selected_poly];
        }
        else if (this.poly_edit.multi_selection) {
          selected_polygons = this.poly_edit.multi_selection;
        }
        if (selected_polygons) {
          this.make_layers_copy();
          for (let layer_idx = 0; layer_idx < this.layers.length; layer_idx += 1) {
            let polygons = [];
            let layer_changed = false;
            const lp = this.layers[layer_idx].config.polygons;
            for (let poly_idx = 0; poly_idx < lp.length; poly_idx += 1) {
              let is_selected = false;
              for (const poly_info of selected_polygons) {
                if (poly_info.layer_uuid == this.layers[layer_idx].uuid && poly_info.poly_idx == poly_idx) {
                  is_selected = true;
                  break;
                }
              }
              if (!is_selected) {
                polygons.push(lp[poly_idx]);
              }
              else {
                layer_changed = true;
              }
            }
            this.layers[layer_idx].config.polygons = polygons;
            if (layer_changed && this.layers[layer_idx].config.polygons.length == 0) {
              removable_layers.push(this.layers[layer_idx].uuid);
            }
          }
          this.layers = this.layers.filter((l) => !removable_layers.includes(l.uuid));
          this.poly_edit.selected_poly = null;
          this.poly_edit.multi_selection = null;
          this.send_layer_updates();
          this.draw_canvas();
        }
        e.preventDefault();
      }
      if (e.key == 'a' && e.ctrlKey) {
        this.poly_edit.selected_poly = null;
        this.poly_edit.multi_selection = [];
        for (let layer_idx = 0; layer_idx < this.layers.length; layer_idx++) {
          const layer = this.layers[layer_idx];
          if (!this.visible_layers[layer.uuid]) {
            continue;
          }
          for (let i = 0; i < layer.config.polygons.length; i++) {
            const poly_info = { layer_uuid: layer.uuid, poly_idx: i };
            this.poly_edit.multi_selection.push(poly_info);
          }
        }
        this.draw_canvas();
        e.preventDefault();
      }
      if (e.key == 'z' && e.ctrlKey) {
        if (this.layers_undo.length) {
          this.layers = cloneDeep(this.layers_undo[this.layers_undo.length - 1]);
          this.layers_undo.pop();
          this.send_layer_updates();
          this.draw_canvas();
        }
      }
      if (e.key == 'e' && e.ctrlKey) {
        if (this.poly_edit.selected_poly) {
          this.toggle_visible_layer(this.poly_edit.selected_poly.layer_uuid);
        }
        e.preventDefault();
      }
    },

    keydown_layers(e) {
      if (this.disabled) return;
      if (e.key == 'z' && e.ctrlKey) {
        if (this.layers_undo.length) {
          this.layers = cloneDeep(this.layers_undo[this.layers_undo.length - 1]);
          this.layers_undo.pop();
          this.send_layer_updates();
          this.draw_canvas();
        }
      }
    },

    // math queries
    get_mouse_pos(event) {
      const canvas = this.$refs.canvas;
      if (!canvas) {
        return null;
      }

      const rect = canvas.getBoundingClientRect();
      let pos = [
        event.clientX - rect.left - canvas.width / 2,
        event.clientY - rect.top - canvas.height / 2,
      ];
      pos[0] /= this.zoom;
      pos[1] /= this.zoom;
      pos[0] -= this.translate[0];
      pos[1] -= this.translate[1];
      return pos;
    },
    get_closest_pt(poly, pt) {
      let closest_pt = null;
      let closest_d = 1000000;
      for (const contour of poly) {
        for (const p of contour) {
          const d = util.pt_distance(p, pt);
          if (d <= closest_d) {
            closest_pt = p;
            closest_d = d;
          }
        }
      }
      return { closest_pt: closest_pt, distance: closest_d };
    },
    get_closest_pts_in_radius(poly, pt, max_distance, limit = null) {
      let points = poly.map((contour) => contour.filter((p) => util.pt_distance(p, pt) < max_distance)).flat();
      if (limit > 0) {
        points = points.sort((a, b) => util.pt_distance(a, pt) - util.pt_distance(b, pt)).slice(0, limit);
      }
      return points;
    },

    is_poly_info(poly_info) {
      return poly_info != null
        && ('layer_uuid' in poly_info)
        && ('poly_idx' in poly_info);
    },

    is_same_poly(p1, p2) {
      if (p1 == null && p2 == null) {
        return true;
      }
      if (!this.is_poly_info(p1) || !this.is_poly_info(p2)) {
        return false;
      }
      return p1.layer_uuid == p2.layer_uuid && p1.poly_idx == p2.poly_idx;
    },

    is_selected(poly) {
      if (this.poly_edit.multi_selection) {
        for (const p of this.poly_edit.multi_selection) {
          if (this.is_same_poly(p, poly)) {
            return true;
          }
        }
        return false;
      }
      return this.is_same_poly(poly, this.poly_edit.selected_poly);
    },

    is_layer_selected(layer_uuid) {
      if (this.poly_edit.multi_selection) {
        for (const p of this.poly_edit.multi_selection) {
          if (p.layer_uuid == layer_uuid) {
            return true;
          }
        }
      }
      else if (this.poly_edit.selected_poly) {
        return (this.poly_edit.selected_poly.layer_uuid == layer_uuid);
      }
      return false;
    },

    select_layer(layer_uuid) {
      if (this.disabled) return;
      const { layer } = this.get_layer(layer_uuid);
      if (layer.config.polygons.length == 1) {
        this.poly_edit.multi_selection = null;
        this.poly_edit.selected_poly = { layer_uuid: layer.uuid, poly_idx: 0 };
        this.draw_canvas();
      }
      if (layer.config.polygons.length > 1) {
        this.poly_edit.selected_poly = null;
        let selection = [];
        for (let i = 0; i < layer.config.polygons.length; i++) {
          selection.push({ layer_uuid: layer.uuid, poly_idx: i });
        }
        this.poly_edit.multi_selection = selection;
        this.draw_canvas();
      }
    },

    get_poly(poly_info) {
      if (poly_info == null) {
        return null;
      }
      for (const layer of this.layers) {
        for (let i = 0; i < layer.config.polygons.length; i++) {
          const poly = layer.config.polygons[i];
          const other_poly = { layer_uuid: layer.uuid, poly_idx: i };
          if (this.is_same_poly(poly_info, other_poly)) {
            return poly;
          }
        }
      }
      return null;
    },

    get_first_intersecting_poly(pt) {
      if (!pt) {
        return null;
      }
      for (let layer_idx = this.layers.length - 1; layer_idx >= 0; layer_idx--) {
        const layer = this.layers[layer_idx];

        const file_id = layer.file_id || this.files[0].id;
        if (file_id !== this.activeFile.id) {
          continue;
        }
        if (!this.visible_layers[layer.uuid]) {
          continue;
        }
        for (let i = layer.config.polygons.length - 1; i >= 0; i--) {
          const poly = layer.config.polygons[i];
          if (check_poly(poly[0], pt) == 1) {
            continue;
          }
          let hole_intersects = false;
          for (const contour of poly.slice(1)) {
            if (check_poly(contour, pt) < 1) {
              hole_intersects = true;
              break;
            }
          }
          if (hole_intersects) {
            continue;
          }

          return {
            layer_uuid: layer.uuid,
            poly_idx: i
          };
        }
      }
      return null;
    },

    start_point_drag(current_pt, mouse_pos) {
      this.mouse.dragged_pt = current_pt;
      this.mouse.dragging_point = true;
      this.mouse.drag_start = { ...mouse_pos };
      this.mouse.drag_offset = [0, 0];
    },

    check_and_remove_points(mouse_pt, should_make_copy, only_closest = false, radius_multiplier = 2.0) {
      const poly = this.get_poly(this.poly_edit.selected_poly);
      const threshold_distance = (this.pt_radius * radius_multiplier) / this.zoom;
      let pts = this.get_closest_pts_in_radius(poly, mouse_pt, threshold_distance, only_closest ? 1 : null);
      if (pts.length === 0) {
        return;
      }
      // create copy of layer for restore
      if (should_make_copy) {
        this.make_layers_copy();
      }
      pts.forEach((pt) => this.remove_point(poly, pt));

      this.remove_invalid_contours(poly);
      const { layer } = this.get_layer(this.poly_edit.selected_poly.layer_uuid);
      this.remove_invalid_polygons(layer);
      this.send_layer_updates();
    },
    mousedown_canvas(event) {
      const mouse_pt = [...this.get_mouse_pos(event)];

      if (event.button == 0) {
        this.mouse.m1_held = true;
      }
      if (event.button == 2) {
        this.mouse.m2_held = true;
      }
      // dragging image
      if (event.button == 1) {
        this.mouse.m3_held = true;
        this.mouse.dragging_polygon = false;
        this.mouse.drag_path_length = 0;
        this.mouse.drag_start = mouse_pt;
        this.mouse.drag_offset = [0, 0];
        // this.poly_edit.selected_poly = null;
        this.poly_edit.multi_selection = null;
        return;
      }
      if (this.samMode) {
        this.mouse.drag_start = mouse_pt;
        return;
      }
      if (this.brush_mode && event.button != 1 && !this.disabled) {
        this.brush_drawing = true;
        if (event.button == 2) {
          this.draw_with_brush(mouse_pt, null, true);
        }
        else {
          this.draw_with_brush(mouse_pt);
        }
        return;
      }

      if (this.fuzzy_mode && !this.disabled) {
        let inside = false;
        if (this.prev_pos) {
          inside = true;
          for (let i = 0; i < 2; i++) {
            if (mouse_pt[i] < this.prev_pos[i] - 1 || mouse_pt[i] > this.prev_pos[i] + 1) { inside = false; }
          }
        }
        if (event.button == 0) {
          if (inside && this.adding_threshold != 255) {
            this.adding_threshold += 5;
          }
          this.flood_fill_contour(mouse_pt, true, true);
        }
        if (event.button == 2) {
          if (inside && this.subtracting_threshold != 255) {
            this.subtracting_threshold += 5;
          }
          this.flood_fill_contour(mouse_pt, false, true);
        }
        this.prev_pos = mouse_pt;
        return;
      }

      if (this.rectangle_mode && !this.disabled) {
        if (event.button == 0) {
          this.rectangle_start = mouse_pt;
        }
        return;
      }

      // removing point
      if (event.button == 2 && !this.disabled) {
        if (this.poly_edit.selected_poly) {
          // on the fly delete points
          if (this.shift_held) {
            if (!this.mouse.on_the_fly_remove) {
              this.make_layers_copy();
              this.mouse.on_the_fly_remove = true;
              this.check_and_remove_points(mouse_pt, false);
            }
          }
          else {
            this.check_and_remove_points(mouse_pt, true, true);
          }
        }
        return;
      }

      // on the fly polygon
      if (this.shift_held
        && !this.poly_edit.multi_selection
        && (!this.poly_edit.selected_poly || !this.visible_layers[this.poly_edit.selected_poly.layer_uuid])
        && !this.disabled) {
        if (!this.mouse.on_the_fly_poly) {
          this.make_layers_copy();
          this.mouse.on_the_fly_poly = [mouse_pt];
          this.add_layer(false);
          this.layers[this.layers.length - 1].config.polygons = [[this.mouse.on_the_fly_poly]];
          this.send_layer_updates();
        }
        else {
          this.mouse.on_the_fly_poly.push(mouse_pt);
          this.layers[this.layers.length - 1].config.polygons = [[this.mouse.on_the_fly_poly]];
        }
        this.draw_canvas();
        return;
      }

      if (!this.poly_edit.multi_selection && event.button != 1 && !this.disabled) {
        // adding point
        if (this.shift_held) {
          if (this.poly_edit.selected_poly) {
            const poly = this.get_poly(this.poly_edit.selected_poly);
            this.make_layers_copy();
            this.add_point(poly, mouse_pt);
            this.send_layer_updates();
          }
          return;
        }

        // dragging point
        if (this.poly_edit.selected_poly) {
          const poly = this.get_poly(this.poly_edit.selected_poly);
          const { closest_pt, distance } = this.get_closest_pt(poly, mouse_pt);
          if (distance <= this.pt_radius / this.zoom) {
            this.make_layers_copy();
            this.start_point_drag(closest_pt, mouse_pt);
            this.draw_canvas();
            return;
          }
        }
      }

      // selecting poly
      if (this.poly_edit.hovered_poly && event.button != 1 && !this.disabled) {
        // multi selection
        if (this.ctrl_held) {
          // already has items
          if (this.poly_edit.multi_selection) {
            // adding hovered poly
            if (!this.is_selected(this.poly_edit.hovered_poly)) {
              this.poly_edit.multi_selection.push(this.poly_edit.hovered_poly);
            }
            // removing from selection hovered poly
            else {
              this.poly_edit.multi_selection = this.poly_edit.multi_selection.filter((p) => !this.is_same_poly(p, this.poly_edit.hovered_poly));
              if (this.poly_edit.multi_selection.length == 0) {
                this.poly_edit.multi_selection = null;
              }
            }
          }
          // has no items yet
          else {
            // has selected poly already and not the same as hovered, so 2 new polygons are selected
            if (this.poly_edit.selected_poly && !this.is_same_poly(this.poly_edit.hovered_poly, this.poly_edit.selected_poly)) {
              this.poly_edit.multi_selection = [this.poly_edit.selected_poly, this.poly_edit.hovered_poly];
            }
            else {
              this.poly_edit.multi_selection = [this.poly_edit.hovered_poly];
            }
          }
          this.poly_edit.selected_poly = null;
          this.draw_canvas();
          return;
        }
        // selecting single polygon for edit mode
        else if (!this.is_selected(this.poly_edit.hovered_poly)) {
          this.poly_edit.selected_poly = this.poly_edit.hovered_poly;
          this.poly_edit.multi_selection = null;
          this.draw_canvas();
          return;
        }
      }

      // dragging poly
      if ((this.poly_edit.selected_poly || this.poly_edit.multi_selection) && event.button != 1) {
        if (this.poly_edit.hovered_poly) {
          this.mouse.drag_path_length = 0;
          this.mouse.drag_start = mouse_pt;
          this.mouse.drag_offset = [0, 0];
          this.mouse.dragging_polygon = true;
          return;
        }
      }

      if (!this.poly_edit.hovered_poly) {
        this.mouse.drag_path_length = 0;
        this.mouse.drag_start = mouse_pt;
        this.mouse.drag_offset = [0, 0];
        if (!this.ctrl_held) {
          this.poly_edit.selected_poly = null;
          this.poly_edit.multi_selection = null;
        }
      }
    },

    mouseup_canvas(event) {
      const mouse_pt = this.get_mouse_pos(event);

      if (event.button == 0) {
        this.mouse.m1_held = false;
      }
      if (event.button == 2) {
        this.mouse.m2_held = false;
      }
      if (event.button == 1) {
        this.dispatchMauseDrag(mouse_pt);
        this.mouse.m3_held = false;
        return;
      }
      // sam mode and no drag detected
      if (this.samMode && !this.samData.loading && JSON.stringify(this.mouse.drag_start) === JSON.stringify(mouse_pt)) {
        this.mouse.drag_start = null;
        if (this.checkSamPointsToRemove(mouse_pt)) {
          this.draw_canvas();
          this.sendSamPoints();
          return;
        }
        if (event.button == 0) {
          this.samData.include.push(mouse_pt);
        }
        if (event.button == 2) {
          this.samData.exclude.push(mouse_pt);
        }
        this.point_hover = true;
        this.draw_canvas();
        this.sendSamPoints();
        return;
      } else if (this.samMode) {
        this.dispatchMauseDrag(mouse_pt);
        return;
      }
      if (this.brush_mode && !this.mouse.drag_start && !this.disabled) {
        this.brush_drawing = false;
        if (event.button == 0) {
          this.draw_with_brush(mouse_pt);
        }
        return;
      }

      if (this.rectangle_mode && !this.disabled) {
        if (event.button == 0) {
          this.get_rectangle(this.rectangle_start, mouse_pt);
          this.rectangle_start = null;
        }
        return;
      }

      if (this.mouse.on_the_fly_remove && !this.disabled) {
        this.mouse.on_the_fly_remove = null;
        this.send_layer_updates();
        this.draw_canvas();
        return;
      }

      if (this.mouse.on_the_fly_poly && !this.disabled) {
        return;
      }
      this.dispatchMauseDrag(mouse_pt);
      this.draw_canvas();
    },

    dispatchMauseDrag(mouse_pt) {
      if (this.mouse.drag_start) {
        this.mouse.drag_offset = util.pt_sub(mouse_pt, this.mouse.drag_start);
        if (this.mouse.dragging_polygon) {
          this.make_layers_copy();
          let polygons = this.poly_edit.multi_selection;
          if (!polygons) {
            polygons = [this.poly_edit.selected_poly];
          }
          for (const poly_info of polygons) {
            const poly = this.get_poly(poly_info);
            for (const contour of poly) {
              for (const pt of contour) {
                pt[0] += this.mouse.drag_offset[0];
                pt[1] += this.mouse.drag_offset[1];
              }
            }
          }
          this.send_layer_updates();
        }
        else if (this.mouse.dragging_point) {
          const dst = util.pt_add(this.mouse.drag_start, this.mouse.drag_offset);
          this.mouse.dragged_pt[0] = dst[0];
          this.mouse.dragged_pt[1] = dst[1];
          this.send_layer_updates();
        }
        else if (this.mouse.drag_path_length == 0 && !this.mouse.dragging_polygon) {
          if (!this.ctrl_held) {
            this.poly_edit.selected_poly = null;
            this.poly_edit.multi_selection = null;
          }
        }
        else {
          this.translate[0] += this.mouse.drag_offset[0];
          this.translate[1] += this.mouse.drag_offset[1];
        }
        this.mouse.drag_offset = [0, 0];
        this.mouse.drag_start = null;
        this.mouse.dragging_polygon = false;
        this.mouse.dragging_point = false;
      }
    },

    mousemove_canvas(event) {
      const prev_pt = cloneDeep(this.mouse.prev_pos);
      const mouse_pt = this.get_mouse_pos(event);
      this.mouse.prev_pos = mouse_pt;

      if (this.mouse.m3_held) {
        this.dispatchMouseMove(mouse_pt, event);
        return;
      }
      if (this.samMode) {
        const pts = this.getClosestSamPoints(mouse_pt, event);
        if (pts.length > 0) {
          this.point_hover = true;
        } else {
          this.point_hover = false;
        }
        this.dispatchMouseMove(mouse_pt, event);
        return;
      }

      if (this.brush_mode && !this.disabled) {
        this.clear_brush_canvas();
        this.brush_mouse_move(mouse_pt);
      }
      if (this.brush_mode && this.brush_drawing && !this.disabled) {
        if (this.mouse.m2_held) {
          this.draw_with_brush(mouse_pt, prev_pt, true);
          return;
        }
        if (this.mouse.m1_held) {
          this.draw_with_brush(mouse_pt, prev_pt);
          return;
        }
      }
      if (this.rectangle_mode && this.mouse.m1_held && !this.disabled) {
        this.clear_hidden_canvas();
        this.draw_rectangle(this.rectangle_start, mouse_pt);
        return;
      }

      if (this.mouse.on_the_fly_remove && !this.disabled) {
        this.check_and_remove_points(mouse_pt, false);
        return;
      }

      if (this.mouse.on_the_fly_poly && !this.disabled) {
        if (this.mouse.m1_held) {
          const last_pt = this.mouse.on_the_fly_poly[this.mouse.on_the_fly_poly.length - 1];
          if (util.pt_distance(mouse_pt, last_pt) > 10 / (this.zoom / 1.5)) {
            this.mouse.on_the_fly_poly.push(mouse_pt);
            this.layers[this.layers.length - 1].config.polygons = [[this.mouse.on_the_fly_poly]];
          }
          this.draw_canvas();
        }
        return;
      }
      this.dispatchMouseMove(mouse_pt, event);
    },

    dispatchMouseMove(mouse_pt, event) {
      this.mouse.drag_path_length += util.pt_len([event.movementX, event.movementY]);
      if (this.mouse.drag_start) {
        this.mouse.drag_offset = util.pt_sub(mouse_pt, this.mouse.drag_start);
        if (this.mouse.dragging_point) {
          this.mouse.dragged_pt[0] = mouse_pt[0];
          this.mouse.dragged_pt[1] = mouse_pt[1];
        }
        this.draw_canvas();
        this.move_hidden_canvas();
      }
      else {
        const poly_info = this.get_first_intersecting_poly(mouse_pt);
        if (!this.is_same_poly(poly_info, this.poly_edit.hovered_poly)) {
          this.poly_edit.hovered_poly = poly_info;
          this.draw_canvas();
        }
      }
    },

    mousewheel_canvas(event) {
      const scroll_increment = Math.pow(2, 1 / 5);
      if (this.brush_mode && !this.brush_drawing && !this.disabled) {
        this.brush_zoom *= Math.pow(scroll_increment, -event.deltaY / 100);
        this.clear_brush_canvas();
        this.brush_mouse_move(this.mouse.prev_pos);
      }
      if (this.brush_mode) {
        return;
      }

      // const scroll_increment = Math.pow(2, 1 / 5);
      this.zoom *= Math.pow(scroll_increment, -event.deltaY / 100);
      const offset = util.pt_sub(this.get_mouse_pos(event), this.mouse.prev_pos);
      this.translate[0] += offset[0];
      this.translate[1] += offset[1];
      this.draw_canvas();
    },

    add_polygon(layer_uuid) {
      this.make_layers_copy();
      for (let layer of this.layers) {
        if (layer.uuid == layer_uuid) {
          // maybe check for visibility
          const size = 50 / this.zoom;

          // a polygon is an array of contours,
          // the first contour is the outline and the rest are holes.
          // a contour is an array of points [x, y]
          layer.config.polygons.push([[
            util.pt_sub([-size, -size], this.translate),
            util.pt_sub([size, -size], this.translate),
            util.pt_sub([size, size], this.translate),
            util.pt_sub([-size, size], this.translate),
          ]]);
          break;
        }
      }
      this.send_layer_updates();
      this.draw_canvas();
    },
    add_hole() {
      const poly = this.get_poly(this.poly_edit.selected_poly);
      if (!poly) {
        return;
      }
      const outline = poly[0];
      if (!outline) {
        return;
      }
      this.make_layers_copy();

      // find bbox
      const bbox = outline.reduce((prev, curr) => {
        prev.left = Math.min(curr[0], prev.left);
        prev.top = Math.min(curr[1], prev.top);
        prev.right = Math.max(curr[0], prev.right);
        prev.bottom = Math.max(curr[1], prev.bottom);
        return prev;
      }, {
        left: 10000000,
        top: 10000000,
        right: -10000000,
        bottom: -10000000,
      });

      let size = [bbox.right - bbox.left, bbox.bottom - bbox.top];
      const center = [bbox.left + size[0] / 2, bbox.top + size[1] / 2];

      size = size.map((dim) => dim * 0.2);

      poly.push([
        [center[0] - size[0], center[1] - size[1]],
        [center[0] - size[0], center[1] + size[1]],
        [center[0] + size[0], center[1] + size[1]],
        [center[0] + size[0], center[1] - size[1]],
      ]);

      this.send_layer_updates();
      this.draw_canvas();
    },

    remove_last_polygon(layer_uuid) {
      for (let layer of this.layers) {
        if (layer.uuid == layer_uuid) {
          if (layer.config.polygons.length > 0) {
            this.make_layers_copy();
            layer.config.polygons.pop();
            this.send_layer_updates();
            this.draw_canvas();
          }
          break;
        }
      }
    },

    toggle_visible_layer(layer_uuid) {
      this.visible_layers[layer_uuid] = !this.visible_layers[layer_uuid];
      this.visible_layers = { ...this.visible_layers };
      this.send_layer_updates();
      this.draw_canvas();
    },

    add_layer(make_copy) {
      if (make_copy) {
        this.make_layers_copy();
      }
      const new_layer = {
        id: null,
        uuid: uuidv4(),
        label_object_set_id: this.sampleSetId,
        tags: [],
        file_id: this.activeFile.id,
        has_tmp_id: true,
        config: { polygons: [] }
      };
      this.layers.push(new_layer);
      this.visible_layers[new_layer.uuid] = true;
      this.visible_layers = { ...this.visible_layers };
      this.send_layer_updates();
    },

    remove_layer(layer_uuid) {
      this.make_layers_copy();
      this.layers = this.layers.filter((sl) => sl.uuid != layer_uuid);
      this.send_layer_updates();
      this.draw_canvas();
    },

    get_layer(layer_uuid) {
      let idx = this.layers.findIndex((layer) => layer.uuid == layer_uuid);
      return { layer: idx === null ? null : this.layers[idx], idx };
    },

    get_layer_color(layer_uuid) {
      const { layer } = this.get_layer(layer_uuid);
      if (layer.tags.length == 1 && layer.tags[0] in this.tag_colors) {
        return this.tag_colors[layer.tags[0]];
      }
      else {
        return layer.config.color;
      }
    },

    set_random_layer_color(layer_uuid) {
      const { layer, idx } = this.get_layer(layer_uuid);
      return this.hsl_to_hex(Math.floor((idx * 25) % 360), 100, 50);
    },

    hsl_to_hex(h, s, l) {
      l /= 100;
      const a = s * (Math.min(l, 1 - l) / 100);
      const f = (n) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0');
      };
      return `#${f(0)}${f(8)}${f(4)}`;
    },

    make_layers_copy() {
      this.layers_undo.push(cloneDeep(this.layers));
      if (this.layers_undo.length > this.max_undo) {
        this.layers_undo.shift();
      }
    },

    send_layer_updates() {
      let result = [];
      for (const layer of this.layers) {
        let result_layer = {};
        result_layer.id = layer.id;
        result_layer.uuid = layer.uuid;
        result_layer.label_object_set_id = layer.label_object_set_id;
        result_layer.label_set_id = layer.label_set_id;
        result_layer.sample_id = layer.sample_id;
        result_layer.sample_set_id = layer.sample_set_id;
        result_layer.tags = layer.tags;
        result_layer.tags_data = layer.tags_data;
        result_layer.config = JSON.stringify(layer.config);
        result_layer.file_id = layer.file_id;
        result.push(result_layer);
      }
      this.$emit('sample-labels-updated', result);
    },

    update_layers(new_layers) {
      this.layers = cloneDeep(new_layers);
      for (let layer of this.layers) {
        let isNewLayer = false;
        if (!layer.uuid) {
          layer.uuid = uuidv4();
          isNewLayer = true;
        }
        if (!layer.config) {
          layer.config = { polygons: [], color: this.set_random_layer_color(layer.uuid) };
        }
        else if (typeof layer.config == 'string') {
          layer.config = JSON.parse(layer.config);

          if (!layer.config.color) {
            layer.config.color = this.set_random_layer_color(layer.uuid);
          }
        }
        if (!(layer.uuid in this.visible_layers)) {
          this.visible_layers[layer.uuid] = true;
        }
        if (isNewLayer && undefined !== this.currentProjectTags.find((pt) => pt.hide && layer.tags.includes(pt.tag_id))) {
          // this is new layer so check if it has tag that makes it hidden by default
          this.visible_layers[layer.uuid] = false;
        }
      }
      if (!this.get_poly(this.poly_edit.selected_poly)) {
        this.poly_edit.selected_poly = null;
      }
      if (this.poly_edit.multi_selection) {
        this.poly_edit.multi_selection = this.poly_edit.multi_selection.filter((p) => Boolean(this.get_poly(p)));
        if (this.poly_edit.multi_selection.length == 0) {
          this.poly_edit.multi_selection = null;
        }
      }
      if (!this.get_poly(this.poly_edit.hovered_poly)) {
        this.poly_edit.hovered_poly = null;
      }
      for (const key of Object.keys(this.visible_layers)) {
        let found = false;
        for (const layer of this.layers) {
          if (layer.uuid == key) {
            found = true;
            break;
          }
        }
        if (!found) {
          delete this.visible_layers[key];
        }
      }
      this.visible_layers = { ...this.visible_layers };
      this.draw_canvas();
    },

    add_point(poly, pt) {
      let closest_d = Infinity;
      let closest_contour = null;
      let closest_index = 0;
      for (const contour of poly) {
        let i = contour.length - 1;
        for (let j = 0; j < contour.length; j++) {
          const p0 = contour[i];
          const p1 = contour[j];
          const d = util.line_distance(pt, p0, p1);
          if (d < closest_d) {
            closest_d = d;
            closest_index = i;
            closest_contour = contour;
          }
          i = j;
        }
      }
      if (closest_contour) {
        closest_contour.splice(closest_index + 1, 0, pt);
        const added_pt = closest_contour[closest_index + 1];
        this.start_point_drag(added_pt, added_pt);
      }
    },

    remove_point(poly, pt) {
      for (const contour of poly) {
        const pt_idx = util.remove(contour, pt);
        if (pt_idx == -1) {
          continue;
        }
      }
    },

    remove_invalid_contours(poly) {
      // we don't want to remove the outline, so start with 1
      for (let i = 1; i < poly.length;) {
        const contour = poly[i];
        if (contour.length < 3) {
          poly.splice(i, 1);
        }
        else {
          i++;
        }
      }
    },

    remove_invalid_polygons(layer) {
      let good_polygons = [];
      for (let i = 0; i < layer.config.polygons.length; i++) {
        const poly = layer.config.polygons[i];
        const poly_info = { layer_uuid: layer.uuid, poly_idx: i };

        if (poly.length > 0 && poly[0].length >= 3) {
          good_polygons.push(poly);
        }
        else {
          if (this.is_same_poly(poly_info, this.poly_edit.selected_poly)) {
            this.poly_edit.selected_poly = null;
          }
          if (this.is_same_poly(poly_info, this.poly_edit.hovered_poly)) {
            this.poly_edit.hovered_poly = null;
          }
        }
      }
      layer.config.polygons = good_polygons;
    },
    on_image_change() {
      if (this.samMode) {
        this.acceptSamPolygon();
      }

      this.poly_edit = {
        selected_poly: null,
        hovered_poly: null,
        multi_selection: null,
      };
    }
  }
};
</script>

<style lang=scss scoped>
/* .cursor_wait{
  cursor: wait;
}
.nocursor {
  cursor:none;
} */
.brush_canvas {
  position: absolute;
  pointer-events: none;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  left: 0;
  opacity: 0.5;
}

.hidden_canvas {
  position: absolute;
  pointer-events: none;
  padding: 0;
  margin: 0;
  opacity: 0.5;
}

.canvas-container {
  overflow: hidden;
}

.obj_normal {
  padding: 0px 5px 4px 15px;
  margin: 0px;
  margin: 0px -8px;

  border-style: solid;
  border-width: 0px 0px 0px 0px;
  border-top: solid 2px #ddd;
  position: relative;

  .ob-control-buttons {
    opacity: 0.1;

    .btn-remove-poly {
      position: relative;
    }

    /* .btn-sm.in-active {
      color:rgb(168, 168, 168);
    } */
  }

  .poly-cnt {
    position: absolute;
    bottom: 1px;
    right: 2px;
    top: inherit;
    display: none;
    font-size: 7pt;
    line-height: 7pt;
  }

  &:hover {
    .poly-cnt {
      display: inline-block;
    }
  }

  &.no-poly {
    .ob-control-buttons {
      .btn-sm:not(.btn-sam-mode):not(.btn-add-poly) {
        opacity: 0.3;
      }

      opacity: 1;
    }
  }

  .ob-color {
    background-color: green;
    width: 5px;
    height: 100%;
    display: inline-block;
    position: absolute;
    left: 0;
    opacity: 0.4;
  }

  &.active {
    .ob-color {
      width: 12px;
      opacity: 1;
    }

    background-color:rgb(252, 252, 252);

    .ob-control-buttons {
      opacity: 0.8;
    }
  }

  &:hover {
    background-color: rgb(226, 226, 226);

    .ob-control-buttons {
      opacity: 1;
    }
  }

  .vue-treeselect div.vue-treeselect__control {
    border-width: 0 0 0px 0;
    border-color: rgb(240, 240, 240);
    background-color: transparent;
    border-radius: 0;
    padding-left: 0;

    /* margin-bottom:2px; */
    .vue-treeselect__multi-value-item {
      background-color: rgb(236, 236, 236);
      color: black;
    }

    .vue-treeselect__value-remove {
      color: red;
    }

    .vue-treeselect__control-arrow-container,
    .vue-treeselect__x-container {
      display: none;
    }
  }
}
</style>
